import Visualization from "../../../utils/services/project/metering/visualizationService";
import crudTemplate from "../../../templates/crudTemplate";
import i18n from "../../../../plugins/i18n";
let crud = crudTemplate(Visualization);
function prepareItem(i) {
  const chartTypeTranslations = {
    areaspline: "visualizations.chart-types.areaspline",
    line: "visualizations.chart-types.line",
    spline: "visualizations.chart-types.spline",
    area: "visualizations.chart-types.area",
    column: "visualizations.chart-types.column"
  };
  if (chartTypeTranslations.hasOwnProperty(i.chart_type)) {
    i.chart_type = i18n.t(chartTypeTranslations[i.chart_type]);
  }
  return i;
}
const state = {
  ...crud.state
};

const getters = {
  ...crud.getters,
  getList(state) {
    //let project = rootGetters["projectStore/getCurrentItem"];
    let list = crud.getters.getList(state);
    return list.map(prepareItem);
  },
  getItem(state) {
    let item = crud.getters.getItem(state);
    item.project_id = item._project && item._project.id;
    return item;
  }
};

const actions = {
  ...crud.actions
};

const mutations = {
  ...crud.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
